module.exports = __webpack_public_path__ + "static/media/robotica-y-programacion-con-arduino.ad364d24.png";